/**
 * Formats a byte count into a human-readable string.
 */
export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B'
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`
}

/**
 * Parses a page range string like "1-5,3,8-10" into an array of page numbers.
 * Returns null if the input is invalid.
 */
export function parsePageRange(
  input: string,
  maxPage: number,
): number[] | null {
  const trimmed = input.trim()
  if (!trimmed) return null

  const parts = trimmed.split(',')
  const pages = new Set<number>()

  for (const part of parts) {
    const range = part.trim().split('-')
    if (range.length === 1) {
      const n = parseInt(range[0], 10)
      if (isNaN(n) || n < 1 || n > maxPage) return null
      pages.add(n)
    } else if (range.length === 2) {
      const start = parseInt(range[0], 10)
      const end = parseInt(range[1], 10)
      if (isNaN(start) || isNaN(end) || start < 1 || end > maxPage || start > end)
        return null
      for (let i = start; i <= end; i++) pages.add(i)
    } else {
      return null
    }
  }

  return Array.from(pages).sort((a, b) => a - b)
}
